import * as yup from 'yup';

export const ForgotPasswordSchema = yup.object({
    username: yup.string().email('Errors.email_invalid').required('Errors.required'),
});
